export class PageInformations {
    pageIndex: number = 0;
    pageSize: number = 10;
    size: number = 10;
    totalElements: number = 0;
    numberOfElements: number = 0;
    totalPages: number = 0;
}
